import { TransactionResponse } from '@ethersproject/abstract-provider'

export type KeyValue = {
  key: SafePoktParams | SafePoktUserParams
  value: unknown
}

export enum SafePoktParams {
  NextEpochTime = 'nextEpochDate',
  NextEpochDate = 'nextEpochDateMS',
  NodeDiscount = 'nodeDiscount',
  CurrentEpoch = 'latestSnapshotIndex',
  BuyPrice = 'poktBuyPrice',
  HolderCount = 'holderCount',
  NewInvestments = 'newInvestments',
  NodeCount = 'totalNodeCount',
  PoktRewards = 'poktRewards',
  ProtToken = 'protToken',
  TotalInvestmentsInUSDC = 'totalInvestmentsInUSDC',
  TotalRewardsPOKT = 'totalPOKTRewards',
  TotalClaimableRewards = 'totalClaimableRewards',
  TotalShares = 'totalPoktShares',
  TotalSupply = 'totalSupply',
  HolderActionsEnabled = 'holderActionsEnabled',
  TotalPOKTStake = 'totalPOKTStake',
  GetNetAPR = 'globalAPY',
  EpochDuration = 'epochDuration',
  PoktPerShare = 'getPoktPerShare',
  NextEpochRPS = 'nextDistributionPoktRPS',
  BuyThreshHold = 'BuyDemandMinAmount',
  CurrentDiscount = 'currentDiscount',
  LatestSnapshotIndex = 'latestSnapshotIndex',
}

export enum SafePoktUserParams {
  Exists = 'exists',
  WillingToClaim = 'willingToClaim',
  PoktReward = 'PoktReward',
  PoktUnHold = 'PoktUnHold',
  PoktUnHoldEpoch = 'PoktUnHoldEpoch',
  SellShareAmount = 'sellShareAmount',
  SellEpoch = 'sellEpoch',
  PoktUnHoldClaimable = 'PoktUnHoldClaimable',
  PoktShareCount = 'poktShareCount',
  RewardClaimable = 'rewardClaimable',
  NoRewardThisEpoch = 'noRewardThisEpoch',
  LatestSnapshotIndex = 'lastSnapshotIndex',
  TotalClaimedUSDC = 'totalClaimedUSDC',
  CanUpdatePercent = 'canChangePercent',
  CanClaimRewards = 'canClaimReward',
  DemandPendingBuys = 'checkPendingBuys'
}

export enum SafePoktEvents {
  WillingToClaim = 'ClaimRateUpdated',
  Deposited = 'Deposited',
  RewardPaid = 'RewardPaid',
  UnHold = 'UnHold',
  NodeAdded = 'NodeAdded',
  BuyPriceUpdate = 'BuyPriceUpdate',
  HolderActionsToggled = 'HolderActionsToggled',
  RewardAdded = 'RewardAdded',
}

export interface UseSafePoktUserParams {
  [SafePoktUserParams.Exists]: boolean
  [SafePoktUserParams.WillingToClaim]: number
  [SafePoktUserParams.PoktReward]: number
  [SafePoktUserParams.PoktUnHold]: number
  [SafePoktUserParams.PoktUnHoldEpoch]: number
  [SafePoktUserParams.SellShareAmount]: number
  [SafePoktUserParams.SellEpoch]: number
  [SafePoktUserParams.PoktUnHoldClaimable]: boolean
  [SafePoktUserParams.PoktShareCount]: number
  [SafePoktUserParams.RewardClaimable]: number
  [SafePoktUserParams.TotalClaimedUSDC]: number
  [SafePoktUserParams.CanClaimRewards]: boolean
  [SafePoktUserParams.CanUpdatePercent]: boolean
  [SafePoktUserParams.LatestSnapshotIndex]: number
  [SafePoktUserParams.NoRewardThisEpoch]: boolean
  [SafePoktUserParams.DemandPendingBuys]: number[]
}

export interface UseSafePoktParams extends UseSafePoktUserParams {
  [SafePoktParams.NextEpochTime]: number | string
  [SafePoktParams.NextEpochDate]: number
  [SafePoktParams.CurrentEpoch]: number
  [SafePoktParams.BuyPrice]: number
  [SafePoktParams.NodeDiscount]: number
  [SafePoktParams.HolderCount]: number
  [SafePoktParams.NewInvestments]: number
  [SafePoktParams.NodeCount]: number
  [SafePoktParams.PoktRewards]: number
  [SafePoktParams.ProtToken]: string
  [SafePoktParams.TotalInvestmentsInUSDC]: number
  [SafePoktParams.TotalRewardsPOKT]: number
  [SafePoktParams.TotalClaimableRewards]: number
  [SafePoktParams.TotalShares]: number
  [SafePoktParams.TotalSupply]: number
  [SafePoktParams.HolderActionsEnabled]: boolean
  [SafePoktParams.TotalPOKTStake]: number
  [SafePoktParams.GetNetAPR]: number
  [SafePoktParams.EpochDuration]: number
  [SafePoktParams.PoktPerShare]: number
  [SafePoktParams.NextEpochRPS]: number
  [SafePoktParams.BuyThreshHold]: number
  [SafePoktParams.CurrentDiscount]: number
  [SafePoktParams.LatestSnapshotIndex]: number

}

export interface UseSafePoktReturnType extends UseSafePoktParams {
  address?: string
  isLoading: boolean
  compoundPoktReward: () => Promise<TransactionResponse>
  buyPokt: (amount: number) => Promise<TransactionResponse>
  buyPoktOnDemand: (amount: number) => Promise<TransactionResponse>
  sellSharesOrder: (amount: number) => Promise<TransactionResponse>
  confirmSellOrderClaimed: () => Promise<TransactionResponse>
  claimReward: () => Promise<TransactionResponse>
  changeClaimPercent: (amount: number) => Promise<TransactionResponse>
  unHoldPoktOrder: (amount: number) => Promise<TransactionResponse>
  //computeDiscount: (shares: number) => Promise<unknown>
  safePoktHistory: (epochNum: number, latestNum: boolean) => Promise<unknown>
}
